var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"onlytitle",class:{ 'fixed': _vm.pic.fixed },style:({ backgroundImage: 'url(' + _vm.background.url + ')' })},[_c('div',{staticClass:"txt"},[_vm._t("title"),_vm._t("subtitle"),_vm._t("content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }